import { defineStore } from 'pinia'
import { ADMIN_TOKEN_KEY, ADMIN_USER_KEY } from '@/config/constants'

export const useUserStore = defineStore('loan-admin-user', {
  state: () => ({
    token: typeof localStorage !== 'undefined' ? localStorage.getItem(ADMIN_TOKEN_KEY) || '' : '',
    username: typeof localStorage !== 'undefined' ? localStorage.getItem(ADMIN_USER_KEY) || '' : '',
  }),
  getters: {
    isLogged(state) {
      return Boolean(state.token)
    },
  },
  actions: {
    hydrateFromStorage() {
      this.token = localStorage.getItem(ADMIN_TOKEN_KEY) || ''
      this.username = localStorage.getItem(ADMIN_USER_KEY) || ''
    },
    setAuth(token: string, username: string) {
      this.token = token
      this.username = username
      localStorage.setItem(ADMIN_TOKEN_KEY, token)
      localStorage.setItem(ADMIN_USER_KEY, username)
    },
    logout() {
      this.token = ''
      this.username = ''
      localStorage.removeItem(ADMIN_TOKEN_KEY)
      localStorage.removeItem(ADMIN_USER_KEY)
    },
  },
})
